import React, { useState, Fragment } from "react";
import { SHORTHCUT_CLICKS } from "../../graphql/queries";
import ShorthcutClicks from ".";
import { Grid, Form } from "tabler-react";
import { useQuery } from "@apollo/react-hooks";

const ShorthcutClicksQueries = () => {
  const [filterDataState, setFilterDataState] = useState("");
  const [pageNumberState, setPageNumberState] = useState(1);
  const [productName, setProductName] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filterHexUsers, setFilterHexUsers] = useState(true);
  const [orderBy, setOrderBy] = useState("");
  const [orderByASC, setOrderByASC] = useState(false);
  const { data, loading } = useQuery(SHORTHCUT_CLICKS, {
    fetchPolicy: "no-cache",
    variables: {
      settings: {
        filter: {
          from: fromDate,
          to: toDate,
          type: productName,
          searchQuery: filterDataState,
          hideHex: filterHexUsers,
        },
        sort: orderBy,
        sortDir: orderByASC ? "ASC" : "DESC",
        page: pageNumberState,
        pageSize: 100,
      },
    },
    notifyOnNetworkStatusChange: true,
  });

  const handleFilterDataChange = (filterData: string) =>
    setFilterDataState(filterData);
  const handlePageNumberChange = (pageNumber: number) =>
    setPageNumberState(pageNumber);
  const handleProductSelect = (productName: string) =>
    setProductName(productName);
  const handleFromDate = (date: string) => setFromDate(date);
  const handleToDate = (date: string) => setToDate(date);

  return (
    <Fragment>
      <Grid.Row>
        <Grid.Col md={2}>
          <Form.Checkbox
            label="Filter Hexact click"
            checked={filterHexUsers}
            onChange={() => setFilterHexUsers(!filterHexUsers)}
          />
        </Grid.Col>
      </Grid.Row>
      <ShorthcutClicks
        data={data}
        loading={loading}
        onFilterDataChange={handleFilterDataChange}
        onPageNumberChange={handlePageNumberChange}
        onProductSelect={handleProductSelect}
        onFromDate={handleFromDate}
        onToDate={handleToDate}
        filterHexScans={filterHexUsers}
        setOrderBy={setOrderBy}
        setOrderByASC={setOrderByASC}
        orderByASC={orderByASC}
        variables={{
          filter: {
            from: fromDate,
            to: toDate,
            type: productName,
            searchQuery: filterDataState,
            hideHex: filterHexUsers,
          },
          sort: orderBy,
          sortDir: orderByASC ? "ASC" : "DESC",
          page: pageNumberState,
          pageSize: 100,
        }}
      />
    </Fragment>
  );
};

export default ShorthcutClicksQueries;
